<template>
    <div class="api-driven-list">
        <div class="list-label" v-if="listLabel != ''">{{listLabel}}</div>
        <div class="border item-wrapper  border-radius">
                <div class="item" :class="itemClass(item)"
                     ref="item"
                     v-for="(item, idx) in items"
                     :key="idx"
                     @mouseover="handleRowItemHover(item, true)"
                     @mouseleave="handleRowItemHover(item, false)"
                     :style="{ fontSize: small ? '12px' : '15px'}"
                     @click="handleRowItemSelected(item)">
                    <div class="row-item" v-for="(column, cidx) in columns" :key="cidx">{{item[column]}}</div>
                </div>
            <div v-if="showLoading" class="loading-indicator"><span class="fa fa-cog fa-spin fa-1x"></span></div>
            <div v-if="showEmpty" class="loading-indicator">Empty</div>
        </div>
        <div class="modifiers">
            <div class="pb-2 search">
                <input class="list-form-element border-radius" type="text" placeholder="Search Filter" @input="handleSearchChange">
            </div>
            <div class="paginator">
                <div class="list-pagi-wrapper">
                    <select class="list-form-element w-25 border-radius" v-if="!small" v-model="per_page" @change="handleResultsPerPageChage">
                        <option>10</option>
                        <option>25</option>
                        <option>50</option>
                        <option>100</option>
                    </select>
                    <div class="paginated-items d-flex" :class="{['w-100 paginated-items--small'] : small}">
                        <button v-if="!small" :class="{'disabled-pagi': current_page <= 1}" @click="handlePreviousNavigation" class="pagi left">Previous</button>
                        <template v-for="(pageObj, idx) in pageLinks">
                            <button v-if="pageObj.clickable"
                                class="pagi middle"
                                :class="[{'selected-pagi':pageObj.page == current_page}, {'left': small && idx === 0}, {'right': small && idx === pageLinks.length - 1}]"
                                :style="{ minWidth: paginationButtonSize }"
                                :key="idx"
                                @click="handleNavigationToPage(pageObj.page)">{{pageObj.label}}
                            </button>
                            <button v-else
                                :key="idx"
                                class="pagi middle disabled-pagi">{{pageObj.label}}
                            </button>
                        </template>
                        <button v-if="!small" :class="{'disabled-pagi': current_page >= last_page}" @click="handleNextNavigation" class="pagi right">Next</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { TweenMax } from "gsap";
import _ from 'lodash';

let base_url = window.location.protocol + "//" + window.location.host

export default {
    name: "select-item-from-api-provided-list",
    props: {
        listLabel: {
            value: String,
            default: ''
        },
        api: String,
        columns: Array,
        resultsKey: String,
        resultsPerPage: {
            type: Number,
            default: 10
        },
        small: {
            type: Boolean,
            default: false
        },
        apiType: {
            type: String,
            default: 'meta'
        },
        filterOn: {
            type: String,
            default: ''
        },
        extraQuery: {
            type: String,
            default: ''
        }
    },
    mounted() {
        if (this.resultsPerPage) {
            this.per_page = this.resultsPerPage;
        }

        if (this.extraQuery) {
            this.connectApi(`?${this.extraQuery}`)
        } else {
            this.connectApi('');
        }
    },
    data() {
        return {
            showLoading: true,
            items: [],
            current_page: 1,
            from: 0,
            to: 0,
            total: 0,
            last_page: 0,
            per_page: 10,
            query: '',
            selectedItem: {},
            hoveredItem: {},
            showEmpty: false,
        };
    },
    computed: {
        pageLinks() {
            let pagelinks = [];

            if (this.last_page <= 7) {
                for (let i = 1; i <= this.last_page; i++) {
                    pagelinks.push({label: i, clickable: true, page: i});
                }

                return pagelinks;
            }

            if (this.current_page <= 4) {
                for (let i = 1; i <= 5; i++) {
                    pagelinks.push({label: i, clickable: true, page: i});
                }
                pagelinks.push({label: '...', clickable: false, page: 0});
                pagelinks.push({label: this.last_page, clickable: true, page: this.last_page});

                return pagelinks;
            }

            if (this.current_page >= (this.last_page-3)) {
                pagelinks.push({label: '1', clickable: true, page: 1});
                pagelinks.push({label: '...', clickable: false, page: 0});
                for (let i = (this.last_page-4); i <= this.last_page; i++) {
                    pagelinks.push({label: i, clickable: true, page: i});
                }

                return pagelinks;
            }

            pagelinks.push({label: '1', clickable: true, page: 1});
            pagelinks.push({label: '...', clickable: false, page: 0});
            pagelinks.push({label: this.current_page-1, clickable: true, page: this.current_page-1});
            pagelinks.push({label: this.current_page, clickable: true, page: this.current_page});
            pagelinks.push({label: this.current_page+1, clickable: true, page: this.current_page+1});
            pagelinks.push({label: '...', clickable: false, page: 0});
            pagelinks.push({label: this.last_page, clickable: true, page: this.last_page});

            return pagelinks;

        },
        paginationButtonSize() {
            return this.small ? '34px' : '40px'
        }
    },
    methods: {
        itemsEqualShallow(a, b) {
            for(let key in a) {
                if(a[key] !== b[key]) {
                    return false;
                }
            }
            return true;
        },
        itemClass(item) {
            if (this.itemsEqualShallow(item, this.selectedItem)) {
                return "selected-item";
            }
            if (item == this.hoveredItem) {
                return "hovered-item";
            }
        },
        handleRowItemHover(item, isOver) {
            if (isOver) {
                if (this.selectedItem != item) {
                    this.hoveredItem = item;
                }
            } else {
                this.hoveredItem = {};
            }
        },
        handleRowItemSelected(item) {
            this.selectedItem = item;
            this.$emit('selection', item);
        },
        handleResultsPerPageChage() {
            this.current_page = 1;

            this.fadeItemsOut();
            this.connectApi('');
        },
        handleSearchChange: _.debounce(function (e) {
            this.handleSearch(e.target.value)
        }, 500),
        handleSearch(bounced) {
            this.query = bounced;
            this.current_page = 1;
            this.fadeItemsOut();
        },
        fadeItemsOut() {
            if (this.$refs.item) {
                TweenMax.staggerTo(this.$refs.item,0.2,{opacity:0}, 0.02, this.handleFadeOutComplete);
            }
        },
        fadeItemsIn() {
            if (this.$refs.item) {
                TweenMax.staggerTo(this.$refs.item,0.2,{opacity:1}, 0.02);
            }
        },
        handleNextNavigation() {
            if (!this.showLoading) {
                this.current_page ++;
                this.fadeItemsOut();
            }
        },
        handleFadeOutComplete(direction) {
            this.navigateTo(this.current_page);
        },
        handlePreviousNavigation() {
            if (!this.showLoading) {
                this.current_page --;
                this.fadeItemsOut();
            }
        },
        handleNavigationToPage(page) {
            if (!this.showLoading) {
                this.current_page = page;
                this.fadeItemsOut();
            }
        },
        navigateTo(page) {
            switch(this.apiType) {
                case 'meta':
                    this.connectApi(`?page=${page}&query=${this.query}&limit=${this.per_page}`);
                    break;
                case 'grid':
                    var api_string = `?page=${page}&filter=${this.query}&per_page=${this.per_page}`;
                    if (this.filterOn) {
                        api_string += `&filter_on=${this.filterOn}`;
                    }
                    if (this.extraQuery) {
                        api_string += `&${this.extraQuery}`;
                    }
                    this.connectApi(api_string);
                    break;
            }

        },
        connectApi(options) {
            this.showLoading = true;
            this.showEmpty = false;
            axios.get(base_url + '/' + this.api + options)
            .then((response) => {

                switch(this.apiType) {
                    case 'meta':
                        this.items = response.data.results;
                        this.current_page = response.data.meta.current_page;
                        this.from = response.data.meta.from;
                        this.to = response.data.meta.to;
                        this.total = response.data.meta.total;
                        this.last_page = response.data.meta.last_page;
                        this.per_page = response.data.meta.per_page;
                        break;
                    case 'grid':
                        this.items = response.data.data;
                        this.current_page = response.data.current_page;
                        this.from = response.data.from;
                        this.to = response.data.to;
                        this.total = response.data.total;
                        this.last_page = response.data.last_page;
                        this.per_page = response.data.per_page;
                        break;
                }

                this.showLoading = false;
                this.fadeItemsIn();
                if (this.current_page > this.last_page) {
                    this.current_page = this.last_page;
                    //need to refresh the data. Asking for a page that is beyond the last page.
                    this.navigateTo(this.current_page);
                }
                if (this.items.length == 0) {
                    this.showEmpty = true;
                }

            })
            .catch((error) => {
                this.showLoading = false;
                console.log('error using api:', this.api);
                console.log(error);
                this.fadeItemsIn();
            });
        },
    }
};
</script>

<style lang="scss" scoped>
    .api-driven-list {
        margin-bottom: 20px;

        .item-wrapper {
            position: relative;
            min-height: 50px;
        }
        .list-label {
            margin: 10px 0;
            font-size: 17px;
        }
        .item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 5px 15px;
            background-color: white;
            font-size: 15px;
            margin: 3px 0;
        }
        .hovered-item {
            background-color: #dedede;
        }
        .selected-item {
            background-color:#1D4E7D;
            color: white;
            pointer-events: none;
        }
        .loading-indicator {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .modifiers {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 5px;
        }
        .list-form-element {
            font-family: "LatoWeb", sans-serif;
            z-index: 0;
            height: 35px;
            border: solid 1px #dedede;
            font-size: 13px;
            color: #333;
            padding: 0 5px;
        }
        select {
            margin-right: 5px
        }
        input {
            width: 200px;
        }
        .list-pagi-wrapper {
            display: flex;
            justify-content: flex-end;
        }
        .pagi {
            height: 35px;
            padding: 0;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            user-select: none;
            border-width: 1px 0;
            border-style: solid;
            border-color: #CDD3E6;
            border-radius: 0;
            cursor: pointer;
            color: #333;

            &.middle {
                border-left: 0;
                border-right: 1px;
                border-style: solid;
                border-color: #CDD3E6;
            }

            &.left {
                padding: 0 10px;
                border-left: 1px;
                border-right: 1px;
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
                border-style: solid;
                border-color: #CDD3E6;
                color: #1D4E7D;
            }

            &.right {
                padding: 0 10px;
                border-left: 0;
                border-right: 1px;
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                border-style: solid;
                border-color: #CDD3E6;
                color: #1D4E7D;
            }

            &.disabled-pagi {
                color: #acb5d2;
                cursor: initial;
                pointer-events: none;
            }
        }
        .selected-pagi {
            background-color: #396095;
            border-color: #396095;
            color: white !important;
            pointer-events: none;
        }
        .pagi:hover {
            background-color: #E7E9F2;
        }
    }
</style>
